import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { mockChildDependents, mockAdultDependents } from './dependents.mocks';

export const mockDependentsFormGroup = new UntypedFormArray([
  new UntypedFormControl({
    ...mockChildDependents[0],
  }),
  new UntypedFormControl({
    ...mockAdultDependents[0],
  }),
  new UntypedFormControl({
    ...mockAdultDependents[1],
  }),
]);

export const mockDependentDetail = {
  dependentType: 'dependentType',
  dependent: mockDependentsFormGroup,
};

export const mockRemoveDependent = {
  ...mockDependentDetail,
  removeIndex: 2,
};
